import React from 'react'
import icon1 from '../../images/update/flag1.png'
import { useTranslation } from 'react-i18next'

const ContactSection = () => {
    const { t } = useTranslation();

    return (
        <section className="contact contact--layout1 contact--simple sitePageSection">
            <div className="container">
                <div className="contactSimple__heading">
                    <h1>{t('menu_contact')}</h1>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="contactBlock text-center">
                            <figure className="contactBlock__figure">
                                <img className="contactBlock__figure__thumb" src={icon1} alt="Türkiye iletişim bilgileri" />
                            </figure>
                            <div className="contactBlock__content">
                                <h2 className="contactBlock__heading text-uppercase">Türkiye Cumhuriyeti</h2>
                                <p className="contactBlock__text">Üngüt Mahallesi 71069. Sokak Loft Apartmanı Kat: 1 No: 1, Onikişubat / Kahramanmaraş</p>
                                <a className="contactBlock__email connect" href="mailto:info@kaed.org.tr">info@kaed.org.tr</a>
                                <a className="contactBlock__phone connect" href="tel:+905545159095">+90 554 515 90 95</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactSection;
